export default "__VITE_ASSET__BsGWt$ZL__"